"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.i18nDatePicker = void 0;
exports.i18nDatePicker = {
    months: [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień",
    ],
    shortMonths: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Cze", "Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
    days: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
    shortDays: ["Nie", "Pon", "Wt", "Śr", "Czw", "Pt", "Sob"],
    goToToday: "Dziś",
    prevMonthAriaLabel: "Poprzedni miesiąc",
    nextMonthAriaLabel: "Następny miesiąc",
    prevYearAriaLabel: "Poprzedni rok",
    nextYearAriaLabel: "Następny rok",
};
